<template>
  <v-container id="result" class="text-center">
            <background1></background1>
      <h1>Final Score</h1>
      <v-btn class='backBtn' color="primary" elevation="20"  @click="$emit('action')">Torna al menu</v-btn>

      <v-simple-table dark aria-label="Risultati finali">
        <thead>
          <tr>
            <th scope="col">La tua risposta</th>
            <th scope="col">Risposta corretta</th>
            <th scope="col">Esito</th>
            <th scope="col">Tempo (s)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="score in scores" :key="score.question">
            <td>{{score.yourAnswer}}</td>
            <td>{{score.rightAnswer}}</td>
            <td>
              <v-icon v-if="score.result == true" color='green' x-large aria-label="Corretto">mdi-trophy</v-icon>
              <v-icon v-else color='red' x-large aria-label="Errato">mdi-circle-off-outline</v-icon>
            </td>
            <td>{{score.timer}}</td>
          </tr>
        </tbody>
      </v-simple-table>
  </v-container>
</template>

<script>
import background1 from './background';
import utils from './utils';
export default {
  props:["scores","sounds"],
  components:{
    background1
  },

  data() {
    return {
          
    } 
  },
  updated() {
    utils.saveData(this.$store.getters.getName,this.$store.getters.getMail,this.scores).then(()=>{console.log("data saved!")});

    
    if (this.sounds.disable==false) {
      this.sounds.intro.play();
    }
    console.log("updating data");

  },
  methods: {

  }
}
</script>

<style scoped>
  .backBtn {
    margin-bottom:1em;
  }

  #result {
    font-family: 'Press Start 2P', cursive;
  }

  #result h1 {
    font-family: 'Press Start 2P', cursive;
    color:#f35c5c;
    font-size:36px;
  }
  #result h4 {
    margin-top:16px;
    color:yellow;


  }
  #result h3 {
    color:white;
    margin-top:24px;
  }
  #result h2 {
    margin:32px;
    color:lightgreen;
  }

  .v-data-table {
    opacity:.7;
  }
  .v-data-table th {
    padding:8px;
  }
  thead,tbody {
    font-size:larger;
  }
</style>